/* eslint-disable @typescript-eslint/no-unused-vars */
import { ActionModalProps } from "components/modals/components/action-modal/types";
import { useAgoricContext } from "context";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { isErrorResult } from "services";
import { confirmSurveyPaymentTrx } from "store/create-survey/survey/actions";
import { partialUpdateModalProps } from "store/modal";
import { PartialUpdateModalProps } from "store/modal/types";
import store, { useAppDispatch } from "store/store";
import { useShowModal } from "..";

const useSendAgoricTransaction = () => {
  const { fundSurvey, sponsorParticipantGas, isConnected, address } = useAgoricContext();

  const dispatch = useAppDispatch();

  const { surveyId } = useParams();

  const { showConfirmationModal } = useShowModal();

  const handleConfirmPayment = async (txHash: string, surveyId: string) => {
    console.log(txHash);
    const _partialProps = partialUpdateModalProps as PartialUpdateModalProps<ActionModalProps>;
    dispatch(confirmSurveyPaymentTrx({ data: { surveyId, txHash } })).then(res => {
      if (!isErrorResult(res.payload)) {
        toast.dismiss();
        showConfirmationModal();
      } else {
        toast.dismiss();
        dispatch(_partialProps({ isLoading: false }));
        toast.error("Please, try again later");
      }
    });
  };

  const handleSendAgoricCreateSurveyTx = async () => {
    const _partialProps = partialUpdateModalProps as PartialUpdateModalProps<ActionModalProps>;
    try {
      dispatch(_partialProps({ isLoading: true }));
      const agoricPaymentData = store.getState().createSurvey.agoricPaymentData;

      if (!isConnected || !address || !agoricPaymentData || !surveyId) {
        toast.error("Agoric wallet is not connected or payment data is missing.");
        return;
      }

      // Calculate gas sponsorship amount: 200000ubld per participant
      const gasAmount = (300000 * agoricPaymentData.participantsLimit).toString();

      // 1st Transaction: Sponsor participant gas fees
      console.log("[AgoricTx] Starting gas sponsorship transaction...");
      const sponsorRes = await sponsorParticipantGas({
        destinationAddress: agoricPaymentData.sponsorAddress,
        amount: gasAmount,
        denom: "ubld",
      });

      if (!sponsorRes.success) {
        throw new Error("Gas sponsorship transaction failed");
      }

      console.log("[AgoricTx] Gas sponsorship successful, txHash:", sponsorRes.txHash);

      // 2nd Transaction: Fund the survey
      console.log("[AgoricTx] Starting survey funding transaction...");
      const res = await fundSurvey({
        surveyId,
        totalAmount: agoricPaymentData.rewardAmount,
        messages: agoricPaymentData.messages,
        denom: agoricPaymentData.denom,
      });

      if (res.success) {
        handleConfirmPayment(res.txHash, surveyId);
      }
    } catch (error) {
      console.error("Error in handleCreateSurveyTransaction", error);
      dispatch(_partialProps({ isLoading: false }));

      const errMsg =
        error instanceof Error
          ? error.message
          : typeof error === "string"
            ? error
            : JSON.stringify(error) || "Transaction failed. Please try again.";

      toast.error(errMsg);
      return;
    }
  };

  return { handleSendAgoricCreateSurveyTx };
};

export default useSendAgoricTransaction;
